import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { Flex, IconButton, Select } from '@radix-ui/themes'
import React from 'react'

import { PageState } from '../interfaces/PageState'
import CardDto from '../interfaces/CardDto'
import { AppPath } from '../enums/AppPath'

import CardTwo from './CardTwo'
import CardOne from './CardOne'

interface CardOneSetProps {
  cardsData: CardDto[]
  docuType: string
  estado: number
  onClickCard?: (id: string) => void
  pageState: PageState
  handlePageChange: (newPage: number) => void
  // New selection props
  isSelectionMode?: boolean
  selectedVehicleIds?: string[]
  onSelectionChange?: (vehicleId: string) => void
}

const CardOneSet: React.FC<CardOneSetProps> = ({
  cardsData,
  docuType,
  estado,
  onClickCard,
  pageState,
  handlePageChange,
  isSelectionMode = false,
  selectedVehicleIds = [],
  onSelectionChange,
}) => {
  const pageSize = pageState.pageSize
  const totalPages = Math.max(1, Math.ceil(cardsData.length / pageSize))
  const pageCurrent = pageState.pageCurrent
  const startIndex = (pageCurrent - 1) * pageSize
  
  const currentData = cardsData.slice(startIndex, startIndex + pageSize)

  let classCard = 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-4 mb-8'

  if (docuType == AppPath.Vehicles || docuType == AppPath.Consignments) {
    classCard = 'w-full lg:w-1/2 px-4 mb-8'
  }

  return (
    <div>
      {docuType !== AppPath.Deals ? (
        <div className="flex flex-wrap -mx-4">
          {currentData.map((card) => (
            <div key={card.id} className={`${classCard}`}>
              <CardOne
                card={card}
                docuType={docuType}
                estado={estado}
                onClickCard={onClickCard}
                pageState={pageState}
                isSelectionMode={isSelectionMode}
                isSelected={selectedVehicleIds.includes(card.id)}
                onSelectionChange={onSelectionChange}
              />
            </div>
          ))}
        </div>
      ) : (
        <CardTwo cards={cardsData} />
      )}

      <Flex direction="row" gap="1" justify="center">
        <IconButton onClick={() => handlePageChange(pageCurrent - 1)} disabled={pageCurrent === 1}>
          <ChevronLeftIcon />
        </IconButton>
        {totalPages > 10 ? (
          <Select.Root defaultValue="1" value={String(pageCurrent)}>
            <Select.Trigger />
            <Select.Content>
              {Array.from({ length: totalPages }, (_, i) => (
                <Select.Item
                  onClick={() => handlePageChange(i + 1)}
                  disabled={pageCurrent === i + 1}
                  value={String(i + 1)}
                  key={i + 1}
                >
                  {i + 1}
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
        ) : (
          <Flex flexShrink="1" overflow="clip" gap="1">
            {Array.from({ length: totalPages }, (_, i) => (
              <IconButton onClick={() => handlePageChange(i + 1)} key={i + 1} disabled={pageCurrent === i + 1}>
                {i + 1}
              </IconButton>
            ))}
          </Flex>
        )}
        <IconButton
          disabled={totalPages < 2 || pageCurrent === totalPages}
          onClick={() => handlePageChange(pageCurrent + 1)}
        >
          <ChevronRightIcon />
        </IconButton>
      </Flex>
    </div>
  )
}

export default CardOneSet
